import ItemSkuBookmarkEditOrderPage from '../../../components/pages/mypages/item_sku_bookmarks/ItemSkuBookmarkEditOrderPage.vue'

export default {
  components: { ItemSkuBookmarkEditOrderPage }
}
